import { useState } from 'react';
import {
  Box,
  Image,
  Group,
  Text,
  Burger,
  Drawer,
} from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import Navbar from './Nav';
import { ForeColorWhite, ForeColorPurple } from '../../lib/constants';

function StickyNavbar() {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [drawerOpened, setDrawerOpened] = useState(false);

  return (
    <Box
      component="header"
      w="100%"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        backgroundColor: ForeColorWhite,
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      }}
    >
      {/* Top Bar – Hidden on mobile */}
      {!isMobile && (
        <Box
          w="100%"
          h="5vh"
          bg={ForeColorPurple}
          px="lg"
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
        >
          <Group spacing="xl" align="center">
            <Group spacing="sm" mr="50px">
              <Image src="img/index/icons/telephone-ico.png" w={20} fit="contain" />
              <a href="tel:+6321234562" style={{ textDecoration: 'none' }}>
                <Text c="white" size="sm">(02) 87900-966</Text>
              </a>
            </Group>

            <Group spacing="sm" mr="100px">
              <Image src="img/index/icons/email-ico.png" w={20} fit="contain" />
              <a href="mailto:inquiry@hotelsogo.com" style={{ textDecoration: 'none' }}>
                <Text c="white" size="sm">inquiry@hotelsogo.com</Text>
              </a>
            </Group>

            <Box
              mr="100px"
              style={{
                width: '1px',
                height: '24px',
                backgroundColor: 'white',
                opacity: 0.5,
              }}
            />

            <Group spacing="xl">
              <a href="https://www.facebook.com/p/Global-Comfort-Group-100054253957756/">
                <Image src="img/index/icons/facebook-ico.png" w={25} fit="contain" />
              </a>
              <Image src="img/index/icons/x-ico.png" w={22} fit="contain" />
              <Image src="img/index/icons/instagram-ico.png" w={22} fit="contain" />
              <Image mr="100px" src="img/index/icons/linkedin-ico.png" w={28} fit="contain" />
            </Group>
          </Group>
        </Box>
      )}

      {/* Main Nav Bar */}
      <Box
        w="100%"
        h={isMobile ? 'auto' : '10vh'}
        py={isMobile ? 20 : 0}
        px="lg"
        bg={ForeColorWhite}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* Logo */}
        <Image style={{display:isMobile?"block":"none",}}src="/img/gcgcIcon.png" w={100} fit="contain" />

        {/* Desktop Nav */}
        {!isMobile && <Navbar />}

        {/* Burger Icon for Mobile */}
        {isMobile && (
          <Burger
            opened={drawerOpened}
            onClick={() => setDrawerOpened((o) => !o)}
            aria-label="Toggle navigation"
          />
        )}
      </Box>

      {/* Mobile Drawer */}
      <Drawer
        opened={drawerOpened}
        onClose={() => setDrawerOpened(false)}
        padding="md"
        size="80%"
        position="right"
        title="Menu"
        zIndex={1001}
      >
        <Navbar isMobile onLinkClick={() => setDrawerOpened(false)} />
      </Drawer>
    </Box>
  );
}

export default StickyNavbar;
